'use strict'

var app = angular.module('app', [
  'ui.router',
  'ngSessionStorage',
  'cfp.loadingBar',
  'ngSanitize',
  'ui.bootstrap',
  'angular-momentjs',
  'ui.mask',
  'ui.bootstrap.datetimepicker',
  '720kb.datepicker',
  'timer'
])

function requireFiles (file) {
  file.keys().forEach(file)
}
requireFiles(require.context('./', true, /\.js$/))



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 35
// module chunks = 0